import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'allsettled-polyfill';
import 'intersection-observer';
import 'scrollyfills';
import 'focus-within-polyfill';
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch';
import globalThisPolyfill from 'globalthis';
import { enableES5 as enableES5ForImmer } from 'immer';

globalThisPolyfill.shim();

// Prevent crash on older samsungs <= 2017 etc. Maybe this can be removed laster
enableES5ForImmer();

// Fix Apollo Client 3 __DEV__
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
if (typeof globalThis.__DEV__ !== 'boolean') {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  globalThis.__DEV__ = false;
}
